import { Avatar, Box, Card, CardContent, CardHeader, Grid, Typography } from '@mui/material';
import { red } from '@mui/material/colors';
import { onValue, ref } from 'firebase/database';
import React, { useEffect, useState } from 'react'
import { firebaseDB } from '../../utils/Firebase';

const Home = () => {
    const db = firebaseDB
    const verifikasi = ref(db, 'verifikasi');
    const proses = ref(db, 'prosesSP2D');
    const ttd = ref(db, 'ttdSP2D');
    const [loket, setLoket] = useState([])
    const [prosesSP2D, setProsesSP2D] = useState([])
    const [ttdSP2D, setTtdSP2D] = useState([])

    useEffect(() => {
        onValue(verifikasi, (snapshot) => {
            const data = snapshot.val();
            if (data === null) {
                setLoket([])
            }
            else {
                let arr = Object.keys(data).map((k) => data[k])
                setLoket(arr)
            }
            // console.log(arr);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        // console.log(prosesSP2D.length);
        onValue(proses, (snapshot) => {
            const data = snapshot.val();
            data === null ? setProsesSP2D([]) : setProsesSP2D(data)
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        // console.log(prosesSP2D.length);
        onValue(ttd, (snapshot) => {
            const data = snapshot.val();
            data === null ? setTtdSP2D([]) : setTtdSP2D(data)
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getFirstChar = (params) => {
        return params.charAt(0);
    }

    return (
        <Box sx={{ pt: 3, flexGrow: 1 }}>
            {/* <Card variant="outlined">{card}</Card> */}

            {/* <Carousel> */}
            <Grid container spacing={2} direction="row" sx={{ p: 2 }}>
                <Grid item xs={12}>
                    <Typography variant="h5" component="div">
                        SPM Diperiksa
                    </Typography>
                </Grid>
                {
                    loket.map((item, index) => (
                        <Grid item xs={12} sm={6} lg={4} key={item.nama} py={1}>
                            <Card>
                                <CardHeader
                                    sx={{ py: 1 }}
                                    avatar={
                                        <Avatar sx={{ bgcolor: red[500] }} aria-label="recipe">
                                            {getFirstChar(item.nama)}
                                        </Avatar>
                                    }
                                    title={
                                        <Typography variant="h6">
                                            {item.nama}
                                        </Typography>
                                    }
                                    subheader={
                                        <Typography sx={{ fontSize: 14 }} color={item.status === 'Sibuk' ? '#ff9800' : '#4caf50'} gutterBottom>
                                            {item.status}
                                        </Typography>
                                    }
                                />
                                <CardContent sx={{ py: 1 }}>
                                    <Typography variant="h5">
                                        No. SPM : {item.no_spm}
                                    </Typography>
                                    <Typography sx={{ fontSize: 18 }} color="text.secondary" gutterBottom>
                                        OPD : {item.opd}
                                    </Typography>

                                </CardContent>
                            </Card>
                        </Grid>
                    ))
                }
            </Grid>
            <Grid container spacing={2} direction="row" sx={{ p: 2 }}>
                <Grid item xs={12}>
                    <Typography variant="h5" component="div">
                        Proses SP2D
                    </Typography>
                </Grid>
                {
                    prosesSP2D.length > 0 ?
                        prosesSP2D.map((item) => (
                            <Grid item xs={12} sm={6} lg={4} key={item.no_spm}>
                                <Card>
                                    <CardContent>
                                        <Typography sx={{ fontSize: 18 }} component="div">
                                            {item.no_spm}
                                        </Typography>
                                        <Typography variant="caption" component="div">
                                            {item.nm_opd}
                                        </Typography>
                                        <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                                            {item.jenis + ' ' + item.jenis_ls}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                        :
                        ""
                }
            </Grid>
            <Grid container spacing={2} direction="row" sx={{ p: 2 }}>
                <Grid item xs={12}>
                    <Typography variant="h5" component="div">
                        SP2D Ditandatangani
                    </Typography>
                </Grid>
                {
                    ttdSP2D.length > 0 ?
                        ttdSP2D.map((item) => (
                            <Grid item xs={12} sm={6} lg={4} key={item.no_spm}>
                                <Card>
                                    <CardContent>
                                        <Typography sx={{ fontSize: 18 }}>
                                            {item.no_spm}
                                        </Typography>
                                        <Typography variant="caption">
                                            {item.nm_opd}
                                        </Typography>
                                        <Typography sx={{ fontSize: 14 }} color="text.secondary">
                                            {item.jenis + ' ' + item.jenis_ls}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))
                        :
                        ""
                }
            </Grid>
            {/* </Carousel> */}
        </Box>
    )
}

export default Home